<template>
  <div
    class="row hero-section text-origami bg-plum text-center text-lg-start"
    data-test="hero-image">
    <div class="col-12 col-lg-6 p-0 video-wrapper">
      <video
        :key="videoUrl"
        :src="videoUrl"
        class="hero-video"
        autoplay
        loop
        playsinline
        alt="Rent an infinite closet, styled just for you. Armoire is a women's clothing rental membership that continuously styles you with curated, contemporary designs for every occasion."
        height="100%"
        width="100%"
        muted/>
    </div>

    <div class="my-lg d-flex flex-column justify-content-center align-items-center align-items-lg-start col-12 col-lg-6">
      <div class="hero-content mx-lg-xxl">
        <h1 class="marketing hero-title text-capitalize text-origami mb-lg-md">
          {{ title ?? '&nbsp;' }}
        </h1>
        <p class="semi-bold mb-lg mb-lg-md hero-subtitle">
          {{ subtitle ?? '&nbsp;' }}
        </p>
        <GetStartedButton
          location="Hero Image"
          variant="secondary"
          class="text-uppercase fixed-width"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useGenericContentStore } from '@shared/stores/genericContent.js'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

const DEFAULT_VIDEO_URL = 'https://d2wwsm0zoxn9fr.cloudfront.net/videos/HomepageLoop2025.mp4'

const { heroImageSection } = storeToRefs(useGenericContentStore())

const title = computed(() => heroImageSection.value?.title)
const subtitle = computed(() => heroImageSection.value?.blocks[0]?.text)
const videoUrl = computed(() => heroImageSection.value?.blocks?.[0]?.video?.videoUrl || DEFAULT_VIDEO_URL)
</script>

<style lang="scss" scoped>
.hero-video {
  object-fit: cover;
  object-position: top left;
  @include media-tablet-or-smaller {
    max-height: 30dvh;
  }
}
.hero-content {
  @include media-tablet-or-smaller {
    padding: 0;
    max-width: 80%;
    margin: 0 auto;
  }
}
.hero-title {
  @include media-desktop {
    max-width: 425px;
  }
}
.video-wrapper {
  height: 30dvh;
  overflow: hidden;
  @include media-desktop {
    height: 40dvh;
    min-height: 425px;
    width: 47% !important;
  }
}
.hero-subtitle {
  max-width: 560px;
}
</style>
